import { createApp } from "vue";
import App from "./App.vue";
import PrimeVue from "primevue/config";
import Aura from "@primeuix/themes/aura";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "./assets/main.css";
import { definePreset } from "@primeuix/themes";
import router from "@/router";

const app = createApp(App);

app.use(router);

const customAura = definePreset(Aura, {
  primitive: {
    fontFamily: "'Outfit', sans-serif",
  },
  semantic: {
    colorScheme: {
      dark: {
        surface: {
          0: "#18181b",
        },
        primary: {
          color: "#E60000",
          inverseColor: "#ffffff",
          hoverColor: "#ff3333",
          activeColor: "#cc0000",
        },
        highlight: {
          background: "rgba(230, 0, 0, 0.1)",
          focusBackground: "rgba(230, 0, 0, 0.2)",
          color: "#E60000",
          focusColor: "#E60000",
        },
      },
    },
  },
});

app.use(PrimeVue, {
  theme: {
    preset: customAura,
    options: {
      prefix: "p",
      darkModeSelector: ".dark-mode",
      cssLayer: false,
    },
  },
});

const webSiteConfig: WebSiteConfig = window.__APP_CONFIG__;

app.config.globalProperties.$webSiteConfig = webSiteConfig;

app.mount("#app");
